export const initialState = {
  moduleSettings: {
    hasAusbildungsplan: false,
    hasPraxisaufgaben: false,
    hasVersetzungsplan: false,
    hasNachweise: false,
    hasWissensportal: false,
    hasChat: false,
    isLoading: false,
  },
}

export default function (state = initialState) {
  return state
}
